import { Button } from "primereact/button";
import { Rating } from "primereact/rating";
import { useState } from "react";
import { isEmptyCheck } from "../../../../utils/commonLogics";

export default function SaveForPresentationPopup({ handleCancelSaveBtnIndex }) {
  const [tagStr, setTagStr] = useState("");
  const [tags, setTags] = useState([]);
  const [notesValue, setNotesValue] = useState("");
  const [ratingValue, setRatingValue] = useState(3);

  const handleSave = () => {
    let savePopupData = {
      tags,
      notesValue,
      ratingValue,
    };
    handleCancelSaveBtnIndex(null);
  };

  const handleTagSubmit = (e) => {
    e.preventDefault(); // prevent page reload
    if (!isEmptyCheck(tagStr)) {
      const textValues = tagStr.split(",");
      setTags([...tags, ...textValues]);
      setTagStr("");
    }
  };

  return (
    <div className="save-for-presentation text-white fs-14">
      <h5 className="text-center">Save for Presentation</h5>
      <div>
        {/* TAGS */}
        <div className="mb-3">
          <label className="form-label fw-bold">Tags</label>
          <div
            className="tags-wrapper p-2"
            style={{
              backgroundColor: "#fff",
              borderRadius: "4px",
              maxHeight: "100px",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <div className="tags-values text-dark d-flex align-items-center flex-wrap mb-2">
              {tags?.length
                ? tags?.map((tag, i) => (
                    <div
                      style={{
                        padding: "4px 8px 4px 4px",
                        border: "1px solid #e5e5e5",
                        background: "#fff",
                        color: "#002133",
                        borderRadius: "3px",
                        margin: "2px",
                      }}
                      key={i}
                    >
                      <div className="d-flex align-items-center">
                        <span>{tag}</span>
                        <span
                          className="ms-2 text-dark fw-bold cursor-pointer fs-12"
                          onClick={() => {
                            const updatedTags = tags?.filter(
                              (_tagData, idx) => idx !== i,
                            );
                            setTags(updatedTags);
                          }}
                        >
                          x
                        </span>
                      </div>
                    </div>
                  ))
                : ""}
            </div>

            <form onSubmit={handleTagSubmit} className="mb-1">
              <input
                type="text"
                className="form-control w-75"
                placeholder="separate with commas"
                value={tagStr}
                onChange={(e) => setTagStr(e.target.value)}
              />
            </form>
          </div>
        </div>

        {/* NOTES */}
        <div className="mb-3">
          <label className="form-label fw-bold">Notes (Optional)</label>
          <textarea
            className="form-control"
            rows="3"
            placeholder="write a note here (optional)"
            value={notesValue}
            onChange={(e) => setNotesValue(e.target.value)}
          ></textarea>
        </div>

        {/* RATING */}
        <div className="mb-3">
          <label className="form-label fw-bold">Rating (Optional)</label>
          <Rating
            value={ratingValue}
            onChange={(e) => setRatingValue(e.value)}
            cancel={false}
            stars={5}
            color="red"
          />
        </div>
      </div>

      {/* BUTTONS */}
      <div className="flex-fill d-flex justify-content-end gap-3 pt-3">
        <Button
          className="px-0 py-0 fw-600"
          style={{ color: "#fff" }}
          link
          onClick={() => handleCancelSaveBtnIndex(null)}
        >
          Cancel
        </Button>
        <Button
          className="pe-3 py-0 fw-600"
          style={{ color: "#fff" }}
          link
          onClick={handleSave}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
